module.exports = __webpack_public_path__ + "assets/startTrip.bd7a7f31.svg";